module.exports = __webpack_public_path__ + "img/solution@2x.8dfb4eee.png";